import { useRegisterModal } from "@/components/home/RegisterModalProvider";
import CTAWhatsAppButton from "@/components/home/CTAWhatsAppButton";
import PhoneMockup from "@/components/home/PhoneMockup";
import Reveal from "@/components/home/Reveal";
import { CheckCircle2 } from "lucide-react";

const CHIPS = ["Plan Free gratis para siempre", "Solo necesitas WhatsApp", "Alta express en minutos"];

export const Hero = () => {
  const { openModal } = useRegisterModal();
  return (
    <section id="inicio" className="relative overflow-hidden bg-brand-cream" data-testid="hero-section">
      <div className="absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full bg-brand-orange/10 blur-3xl pointer-events-none" />
      <div className="mt-container mt-section grid lg:grid-cols-[1.1fr_0.9fr] gap-12 lg:gap-8 items-center">
        <div>
          <Reveal>
            <span className="inline-flex items-center gap-2 bg-white border border-orange-200 text-brand-orange-dark text-xs sm:text-sm font-semibold px-3 py-1.5 rounded-full">
              <span className="w-2 h-2 rounded-full bg-brand-green animate-pulse" /> 0% de comisión en todos los planes · desde $0 USD
            </span>
          </Reveal>
          <Reveal delay={80}>
            <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-brand-carbon" data-testid="hero-title">
              Quédate con el <span className="text-brand-orange">100%</span> de cada peso que vendes.
            </h1>
          </Reveal>
          <Reveal delay={160}>
            <p className="mt-6 text-base md:text-lg text-gray-700 max-w-xl leading-relaxed">
              MenuThere convierte la foto de tu menú en un sistema de pedidos por WhatsApp con alta express: en minutos ya estás vendiendo. Sin comisiones. Sin app intermediaria. Sin dar de alta a nadie más como dueño de tu cliente.
            </p>
          </Reveal>
          <Reveal delay={240}>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <button onClick={() => openModal({ plan: "Free", source: "plan" })} className="btn-mt btn-mt-primary btn-mt-lg" data-track="hero-empezar" data-testid="hero-empezar-button">Empezar gratis</button>
              <CTAWhatsAppButton label="Hablar con Richard" variant="outline" track="hero-asesor" testId="hero-asesor-link" className="btn-mt-lg" />
            </div>
          </Reveal>
          <Reveal delay={320}>
            <ul className="mt-6 flex flex-wrap gap-x-5 gap-y-2 text-sm font-medium text-gray-700">
              {CHIPS.map((c) => <li key={c} className="flex items-center gap-1.5"><CheckCircle2 className="w-4 h-4 text-brand-green" /> {c}</li>)}
            </ul>
          </Reveal>
          <Reveal delay={400}>
            <p className="mt-6 text-sm text-gray-500">
              Le ordenaron <b className="text-brand-carbon">$400 MXN</b>. Se queda con <b className="text-brand-green">$400 MXN</b>. Así de simple.
            </p>
          </Reveal>
        </div>
        <Reveal delay={200} className="flex justify-center lg:justify-end">
          <PhoneMockup />
        </Reveal>
      </div>
    </section>
  );
};

export default Hero;
